import { useCallback, useState } from 'react'

/**
 * The open `<dialog>` an element sits in, if any. A modal dialog lives in the browser's top layer,
 * above everything in the page, so a menu or tooltip portalled to `document.body` opens UNDER it.
 * Floating layers portal into this host instead; outside a dialog it is undefined (= body).
 * Put `ref` on the element that opens the layer and pass `host` as the portal's container.
 */
export function useLayerHost() {
	const [host, setHost] = useState<HTMLElement | undefined>(undefined)
	const ref = useCallback(
		(el: HTMLElement | null) => setHost(el?.closest('dialog') ?? undefined),
		[],
	)
	return { ref, host }
}
